export { default as MicrosoftVerify } from './MicrosoftVerify'

export { default as TokenVerify } from './TokenVerify'